<template>
    <div>
        <br>
    <h2 class="text-xs-center">Λίστα Συγγραμμάτων προς Ανταλλαγή</h2>
        <v-layout justify-end>
        <v-btn @click="openNonEudoxusExchangeComponent()"
               slot="activator"
               round
               class="mr-4 mt-4"
               color="warning"
                small>
            <span class="editButton">Συγγράμματα εκτός Ευδόξου</span>
        </v-btn>
        </v-layout>
        <EudoxusExchangeComponent/>

        <v-dialog v-model="dialog">
            <v-card>
                <v-card-title
                        class="headline secondary white--text justify-center"
                        primary-title
                >Συγγράμματα που παραλήφθηκαν εκτός Ευδόξου</v-card-title>
            <NonEudoxusExchangeComponent />
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog = false"
                            color="primary darken-0">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>

            </v-card>
            <!--<v-card>-->
                <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                <!--<v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text>-->
                <!--<v-card-actions>-->
                    <!--<v-spacer></v-spacer>-->
                    <!--<v-btn color="green darken-1" flat="flat" @click.native="dialog = false">Disagree</v-btn>-->
                    <!--<v-btn color="green darken-1" flat="flat" @click.native="dialog = false">Agree</v-btn>-->
                <!--</v-card-actions>-->
            <!--</v-card>-->
        </v-dialog>

    <!--<v-tabs-->
            <!--color="grey lighten-3"-->
            <!--light-->
            <!--centered-->
            <!--height="65px"-->
            <!--icons-and-text>-->
        <!--<v-tabs-slider color="primary"></v-tabs-slider>-->

        <!--<v-tab href="#tab-1" active-class="default-class elevation-24">-->
            <!--Συγγράμματα που παραλήφθηκαν στον Εύδοξο-->
        <!--</v-tab>-->

        <!--<v-tab href="#tab-2" active-class="default-class elevation-24">-->
            <!--Συγγράμματα που παραλήφθηκαν εκτός Ευδόξου-->
        <!--</v-tab>-->


        <!--<v-tab-item-->
                <!--v-for="i in 2"-->
                <!--:id="'tab-' + i"-->
                <!--:key="i">-->
            <!--<EudoxusExchangeComponent v-if="i === 1"></EudoxusExchangeComponent>-->
            <!--<NonEudoxusExchangeComponent v-else></NonEudoxusExchangeComponent>-->
        <!--</v-tab-item>-->
    <!--</v-tabs>-->
    </div>
</template>


<script>
    import EudoxusExchangeComponent from "./EudoxusExchangeComponent";
    import NonEudoxusExchangeComponent from "./NonEudoxusExchangeComponent";
    import {GlobalEudoxusBus} from  "../../main";

    export default {
        data () {
            return {
                dialog: false
            }
        },
        name: "BookExchangeTabsComponent",
        components: {NonEudoxusExchangeComponent, EudoxusExchangeComponent},
        methods: {
            openNonEudoxusExchangeComponent() {
                GlobalEudoxusBus.$emit('initVariables');
                this.$store.commit('setSolarResponse', []);
                this.dialog = true;
            }
        }
    }
</script>

<style scoped>
    .editButton {
        font-size: small;
        padding-right: 5px;
    }
</style>
